// Lightweight auth hook. Reads from localStorage, listens for the custom
// "pbo-auth-change" event so all mounted components update simultaneously.
import { useEffect, useState } from "react";
import { getAuth } from "@/lib/authApi";

export default function useAuth() {
  const [auth, setState] = useState(() => getAuth());

  useEffect(() => {
    const onChange = () => setState(getAuth());
    window.addEventListener("pbo-auth-change", onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener("pbo-auth-change", onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);

  return {
    user: auth?.user || null,
    isSignedIn: !!auth?.user,
    token: auth?.session_token || null,
  };
}
